module.exports = __webpack_public_path__ + "img/base-account.a9fa9665.png";